export const subscriptionConstants = {
    GET_USERS_LOADING: "GET_USERS_LOADING",
    GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
    GET_USERS_FAILURE: "GET_USERS_FAILURE",
    
  VIEW_CUSTOMER_PORTAL_LOADING: "VIEW_CUSTOMER_PORTAL_LOADING",
  VIEW_CUSTOMER_PORTAL_SUCCESS: "VIEW_CUSTOMER_PORTAL_SUCCESS",
  VIEW_CUSTOMER_PORTAL_FAILURE: "VIEW_CUSTOMER_PORTAL_FAILURE",
  };
  